export function formatAiSystemTimestamp(value) {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatLastUpdatedBy(name, timestamp) {
  const when = formatAiSystemTimestamp(timestamp);
  if (name && when) {
    return `${name} · ${when}`;
  }
  return name || when || "";
}
